import ahoy from 'ahoy.js'

const widget = document.querySelector('[data-chatbot-widget]')
if (widget) {
  let chatbotOpen = false

  window.addEventListener('message', (event) => {
    let data
    try {
      data =
        typeof event.data === 'string' ? JSON.parse(event.data) : event.data
    } catch {
      return
    }

    if (data.type === 'resize') {
      const isOpen = data.payload && parseInt(data.payload.height, 10) > 100
      if (isOpen && !chatbotOpen) {
        chatbotOpen = true
        ahoy.track('Chatbot Opened', { page: window.location.pathname })
      } else if (!isOpen && chatbotOpen) {
        chatbotOpen = false
        ahoy.track('Chatbot Closed', { page: window.location.pathname })
      }
    } else if (data.type === 'openLink') {
      ahoy.track('Chatbot Link Clicked', {
        url: data.payload,
        page: window.location.pathname,
      })
    }
  })
}
